import { observable, toJS } from 'mobx';
import moment from 'moment';
import api from '../api';
import UserStore from './UserStore';
import { Operators } from '../utils/constants';

const props = {
  loading: {
    status: false,
    msg: 'Chargement en cours',
  },
  columns: [
    {
      Header: 'N°',
      accessor: 'id',
      field: 'id',
      // isHidden: true,
    },
    {
      Header: 'Produit',
      accessor: 'produit',
      field: 'produit',
      // isHidden: true,
    },
    {
      Header: 'Action réalisée',
      accessor: 'action',
      field: 'action',
      // isHidden: true,
    },
    {
      Header: 'Ancien Prix Marché',
      accessor: 'ancienPrixCourant',
      field: 'ancienPrixCourant',
      // isHidden: true,
    },
    {
      Header: 'Nouveau Prix Marché',
      accessor: 'nouveauPrixCourant',
      field: 'nouveauPrixCourant',
      // isHidden: true,
    },
    {
      Header: 'Nouvelle Date Début Validité Prix Marché',
      accessor: 'newDateDebutValiditePrixCourant',
      field: 'newDateDebutValiditePrixCourant',
      // isHidden: true
      Cell: ({ cell: { value } }) => {
        if (moment(value).isValid())
          return moment(value).format('DD/MM/YYYY HH:mm:ss');
        else return '-';
      },
    },
    {
      Header: 'Nouvelle Date Fin Validité Prix Marché',
      accessor: 'newDateFinValiditePrixCourant',
      field: 'newDateFinValiditePrixCourant',
      // isHidden: true
      Cell: ({ cell: { value } }) => {
        if (moment(value).isValid())
          return moment(value).format('DD/MM/YYYY HH:mm:ss');
        else return '-';
      },
    },
    {
      Header: 'Ancienne Date Début Validité Prix Marché',
      accessor: 'oldDateDebutValiditePrixCourant',
      field: 'oldDateDebutValiditePrixCourant',
      // isHidden: true
      Cell: ({ cell: { value } }) => {
        if (moment(value).isValid())
          return moment(value).format('DD/MM/YYYY HH:mm:ss');
        else return '-';
      },
    },
    {
      Header: 'Ancienne Date fin Validité Prix Marché',
      accessor: 'oldDateFinValiditePrixCourant',
      field: 'oldDateFinValiditePrixCourant',
      // isHidden: true
      Cell: ({ cell: { value } }) => {
        if (moment(value).isValid())
          return moment(value).format('DD/MM/YYYY HH:mm:ss');
        else return '-';
      },
    },
    {
      Header: 'Ancien Prix de Référence',
      accessor: 'ancienPrixRef',
      field: 'ancienPrixRef',
      // isHidden: true
      Cell: ({ cell: { value } }) => {
        if (!value) return 0;
        return value;
      },
    },
    {
      Header: 'Nouveau Prix de Référence',
      accessor: 'nouveauPrixRef',
      field: 'nouveauPrixRef',
      // isHidden: true
      Cell: ({ cell: { value } }) => {
        if (!value) return 0;
        return value;
      },
    },
    {
      Header: 'Nouvelle Date Début Validité Prix Référence',
      accessor: 'newDateDebutValiditePrixRef',
      field: 'newDateDebutValiditePrixRef',
      // isHidden: true
      Cell: ({ cell: { value } }) => {
        if (moment(value).isValid())
          return moment(value).format('DD/MM/YYYY HH:mm:ss');
        else return '-';
      },
    },
    {
      Header: 'Nouvelle Date Fin Validité Prix Référence',
      accessor: 'newDateFinValiditePrixRef',
      field: 'newDateFinValiditePrixRef',
      // isHidden: true
      Cell: ({ cell: { value } }) => {
        if (moment(value).isValid())
          return moment(value).format('DD/MM/YYYY HH:mm:ss');
        else return '-';
      },
    },
    {
      Header: 'Ancienne Date Début Validité Prix Référence',
      accessor: 'oldDateDebutValiditePrixRef',
      field: 'oldDateDebutValiditePrixRef',
      // isHidden: true
      Cell: ({ cell: { value } }) => {
        if (moment(value).isValid())
          return moment(value).format('DD/MM/YYYY HH:mm:ss');
        else return '-';
      },
    },
    {
      Header: 'Ancienne Date fin Validité Prix Référence',
      accessor: 'oldDateFinValiditePrixRef',
      field: 'oldDateFinValiditePrixRef',
      // isHidden: true
      Cell: ({ cell: { value } }) => {
        if (moment(value).isValid())
          return moment(value).format('DD/MM/YYYY HH:mm:ss');
        else return '-';
      },
    },
    {
      Header: 'Utilisateur',
      accessor: 'utilisateur',
      field: 'utilisateur',
      // isHidden: true,
    },
    {
      Header: 'Date des modifications',
      accessor: 'dateAction',
      field: 'dateAction',
      // isHidden: true
      Cell: ({ cell: { value } }) => {
        if (moment(value).isValid())
          return moment(value).format('DD/MM/YYYY HH:mm:ss');
        else return '-';
      },
    },
  ],
  pattern: {
    DateAction: {
      active: true,
      title: 'Date Action',
      canAddOr: false,
      name: 'dateAction',
      operator: {
        type: 'select',
        list: ['between'].map((item) => ({ id: item, label: Operators[item] })),
      },
      field: {
        name: 'dateAction',
        type: 'date',
      },
      value: [
        {
          name: 'dateAction',
          field: 'DATE(dateAction)',
          type: 'date',
          // custom: true,
          operator: 'between',
          value: [
            moment().subtract('1', 'months').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD'),
          ],
        },
      ],
      defaultValue: {
        name: 'dateAction',
        field: 'DATE(dateAction)',
        type: 'date',
        // custom: true,
        operator: 'between',
        value: [
          moment().subtract('1', 'months').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
        ],
      },
    },
  },
  data: [],
  pageStart: 0,
  pageIndex: 0,
  pageLimit: 30,
  pageTotal: 0,
  pageCount: 0,
  total_gain: null,
  savedPattern: {},
  savedFilters: [],
  loadedFilter: null,
  isOpenModalSave: false,
};

const PrixProduitFilterStore = {
  props: props,
  doLoading(state, msg = '') {
    this.props.loading.msg = msg;
    this.props.loading.status = state;
  },

  async init(pattern) {
    this.reset();
    this.doLoading(true, 'Chargement en cours ...');
    if (pattern) this.props.pattern = pattern;
    console.log('initfilter');
    await this.initColumnsPrices();

    await this.getPrices();

    this.doLoading(false);
  },
  async initColumnsPrices() {
    return new Promise((resolve) => {
      this.props.columns = this.props.columns.map((item) => {
        return item;
      });

      resolve(true);
    });
  },

  async getPrices() {
    this.props.sortBy = this.props.sortBy || 'id';
    this.props.sortOrder = this.props.sortOrder || 'DESC';
    const idRes = UserStore.props.user.idRes;

    let where = '';

    if (UserStore.isReseau()) where = this.getWhere('idres = ' + idRes);
    else where = this.getWhere('idres = ' + idRes);

    // let where = this.getWhere(mainWhere)
    let data = {
      objName: 'priceTrackChangeList',
      cmd: 'getRows',
      where: where,
      start: this.props.pageStart,
      limit: this.props.pageLimit,
      sort: this.props.sortBy,
      dir: this.props.sortOrder,
      // 'query': JSON.stringify(where)
    };

    const res = await api.post('/scripts/reseau/reseau.php', data);
    console.log(res);
    if (res.data.success) {
      if (res.data.rows) {
        this.props.data = !res.data.rows ? [] : res.data.rows;
        this.props.pageTotal = res.data.totalCount;
        this.props.pageCount = Math.ceil(
          res.data.totalCount / this.props.pageLimit
        );
      } else {
        this.props.data = [];
      }
    }
    // this.props.loading.status = false
  },
  async getFilteredPrices() {
    this.doLoading(true, 'Chargement en cours ...');
    await this.getPrices();
    this.doLoading(false);
  },
  async nextPage() {
    this.props.pageIndex = this.props.pageIndex + 1;
    this.props.pageStart = this.props.pageIndex * this.props.pageLimit;
    this.doLoading(true, 'Chargement en cours ...');
    await this.getPrices();
    this.doLoading(false);
  },
  async prevPage() {
    this.props.pageIndex = this.props.pageIndex - 1;
    this.props.pageStart = this.props.pageIndex * this.props.pageLimit;
    this.doLoading(true, 'Chargement en cours ...');
    await this.getPrices();
    this.doLoading(false);
  },
  async goToPage(page) {
    this.props.pageIndex = page;
    this.props.pageStart = this.props.pageIndex * this.props.pageLimit;
    this.doLoading(true, 'Chargement en cours ...');
    await this.getPrices();
    this.doLoading(false);
  },
  toggleItemFilter(key) {
    if (!this.props.pattern[key].isNotToggable)
      this.props.pattern[key].active = !this.props.pattern[key].active;
  },
  activateItemFilter(key) {
    if (!this.props.pattern[key].isNotToggable)
      this.props.pattern[key].active = true;
  },
  changeOperator(key, val, index) {
    console.log(val);
    this.props.pattern[key].value[index].operator = val;
    if (val === 'between') {
      this.props.pattern[key].value[index].value = [null, null];
    } else {
      this.props.pattern[key].value[index].value = '';
    }
  },
  changeValue(key, val, index, order) {
    console.log('changeValue key', key);
    console.log('changeValue val', val);
    console.log('changeValue pattern', this.props.pattern[key]);
    if (this.props.pattern[key].value[index].operator === 'between') {
      this.props.pattern[key].value[index].value[order] = val;
    } else if (this.props.pattern[key].value[index].operator === 'in') {
      if (val !== 'all') {
        let position = this.props.pattern[key].value[index].value.findIndex(
          (o) => o === val
        );
        console.log('position :', position);
        if (position === -1)
          this.props.pattern[key].value[index].value = [
            ...this.props.pattern[key].value[index].value,
            val,
          ];
        else
          this.props.pattern[key].value[index].value = [
            ...this.props.pattern[key].value[index].value.filter(
              (item) => item !== val
            ),
          ];
      } else {
        if (
          this.props.pattern[key].field.list.length !==
          this.props.pattern[key].value[index].value.length
        ) {
          this.props.pattern[key].value[index].value = [
            ...this.props.pattern[key].field.list.map((item) => item.id),
          ];
        } else {
          this.props.pattern[key].value[index].value = [];
        }
      }
    } else {
      this.props.pattern[key].value[index].value = val;
    }
    console.log(toJS(this.props.pattern[key].value[index].value));
  },
  addItemFilter(key, type) {
    let newVal = { ...this.props.pattern[key].defaultValue };
    newVal.logic = type;
    this.props.pattern[key].value = [...this.props.pattern[key].value, newVal];
  },
  removeItemFilter(key, idx) {
    this.props.pattern[key].value = [
      ...this.props.pattern[key].value.filter((item, index) => index !== idx),
    ];
  },
  submitFilter() {
    this.props.savedPattern = toJS(this.props.pattern);
    this.getCountActiveFilter();
  },

  resetFilter() {
    Object.keys(this.props.pattern).map((item) => {
      this.props.pattern[item].value = props.pattern[item].value;
      this.props.savedPattern[item].value = props.pattern[item].value;
      this.props.pattern[item].active = false;
      this.props.savedPattern[item].active = false;
    });

    this.activateItemFilter('dateAction');
  },
  undoPattern() {
    this.props.pattern = toJS(this.props.savedPattern);
  },
  getWhere(where = '') {
    const main = [
      ...Object.keys(this.props.pattern)
        .filter((item) => this.props.pattern[item].active)
        .map((item) => toJS(this.props.pattern[item].value)),
    ];

    console.log(main);
    for (let key in main) {
      if (main[key].isHidden) continue;
      if (where.length) {
        if (main[key].length) where += ' AND ( ';
      } else where += '( ';
      let pass = 0;
      for (let id in main[key]) {
        if (pass) where += ' ' + main[key][id].logic + ' ';
        pass = 1;

        where += this.getClause(main[key][id], main[key][id].custom);
      }

      if (where.length) {
        if (main[key].length) where += ')';
      }
    }

    return where;
  },
  getClause(clause, isCustom = false) {
    let where = '-+--+-+ ERR -++-+-+';
    if (clause.operator === 'in') {
      where = clause.field + ' IN (' + clause.value.join(',') + ') ';
      console.log(where);
    } else if (clause.operator === 'between') {
      if (clause.type === 'date') {
        where =
          clause.field +
          " BETWEEN '" +
          clause.value[0] +
          "' AND '" +
          clause.value[1] +
          "' ";
      } else if (clause.type === 'number') {
        where =
          clause.field +
          ' BETWEEN ' +
          clause.value[0] +
          ' AND ' +
          clause.value[1] +
          ' ';
      } else {
        where = '__ERROR__1';
      }
    } else if (clause.operator === 'like' || clause.operator === 'not like') {
      if (clause.type === 'text') {
        where =
          clause.field + ' ' + clause.operator + " '%" + clause.value + "%' ";
      } else {
        where = '__ERROR__2';
      }
    } else if (
      clause.operator === '>' ||
      clause.operator === '<' ||
      clause.operator === '>=' ||
      clause.operator === '<=' ||
      clause.operator === '<>' ||
      clause.operator === '='
    ) {
      if (clause.type === 'date' || clause.type === 'text') {
        where =
          clause.field + ' ' + clause.operator + " '" + clause.value + "' ";
      } else if (clause.type === 'number') {
        where = clause.field + ' ' + clause.operator + ' ' + clause.value + ' ';
      } else {
        where = '__ERROR__3';
      }
    } else {
      where = '__ERROR__4';
    }
    if (isCustom)
      return clause.field.replace('_$$$_', where.replace(clause.field, ''));
    return where;
  },
  getCountActiveFilter() {
    this.props.countActiveFilter = Object.keys(this.props.pattern).filter(
      (item) => this.props.pattern[item].active
    ).length;
  },
  //FILTER ACTIONS
  getCurrentFilterJson() {
    let filter = {};

    Object.keys(this.props.pattern)
      .filter((item) => this.props.pattern[item].active)
      .map((item) => {
        filter[item] = this.props.pattern[item].value;
      });

    return toJS(filter);
  },
  reset() {
    this.props = props;
  },
};

export default observable(PrixProduitFilterStore);
